import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {Master} from '../../../../admin/models/master.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ClassifiersFormComponent} from '../classifiers-form/classifiers-form.component';
import {MasterForm} from '../../../models/master-form';
import {ClassifierEditEvent} from '../../../models/classifier-edit-event.interface';
import {Router} from '@angular/router';

@Component({
  selector: 'app-classifiers-table',
  templateUrl: './classifiers-table.component.html',
  styleUrls: ['./classifiers-table.component.scss']
})
export class ClassifiersTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['code', 'description', 'comment', 'actions'];

  @Input()
  list!: Master[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;
  @Input()
  origin!: string;
  @Input()
  originStep!: number;

  @Output()
  loadItems: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  createItem: EventEmitter<ClassifierEditEvent> = new EventEmitter<ClassifierEditEvent>();
  @Output()
  updateItem: EventEmitter<ClassifierEditEvent> = new EventEmitter<ClassifierEditEvent>();
  @Output()
  deleteItem: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog, private router: Router) {
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadItems.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadItems.emit({page: event.pageIndex, size: event.pageSize});
  }


  add(): void {
    const dialogRef = this.dialog.open(ClassifiersFormComponent, {data: {}, maxWidth: 600, width: 'inherit'});
    dialogRef.componentInstance.save.subscribe((classifier) => {
      this.createItem.emit({classifier, dialogRef});
    });
  }

  edit(item: MasterForm): void {
    const dialogRef = this.dialog.open(ClassifiersFormComponent, {data: {item}, maxWidth: 600, width: 'inherit'});
    dialogRef.componentInstance.save.subscribe((classifier) => {
      this.updateItem.emit({classifier, dialogRef});
    });
  }

  updateDisabled(item: Master, disabled: boolean): void {
    this.updateDisabledProperty(item, disabled);
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${disabled ? 'Disable' : 'Enable'} classifier`,
            text: `Are you sure you want to ${disabled ? 'deactivate' : 'activate'} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe(
      (confirm: boolean) => {
        if (confirm) {
          const updatedItem = {...item};
          updatedItem.disabled = disabled;
          this.updateItem.emit({classifier: updatedItem, dialogRef});
        } else {
          this.updateDisabledProperty(item, !disabled);
        }
        dialogRef.close();
      }
    );

    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.confirm.unsubscribe();
    });
  }

  delete(id: number): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: 'Delete classifier',
            text: 'Are you sure you want to delete the selected item?'
          }
      });
    dialogRef.componentInstance.confirm.subscribe(
      (confirm: boolean) => {
        if (confirm) {
          this.deleteItem.emit(id);
        }
        dialogRef.close();
      }
    );

    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.confirm.unsubscribe();
    });
  }

  private updateDisabledProperty = (item: Master, disabled: boolean) => {
    const updatedList = [...this.list];
    this.list.map(master => {
      if (master.id === item.id) {
        master.disabled = disabled;
      }
    });
    this.list = updatedList;
  }

  backToReportCycle(): void {
    this.router.navigate([this.origin], {state: {wizardStep: this.originStep}});
  }
}
